// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  /* //LOCAL
  apiUrl: 'http://localhost:8080/maxiplusAdm-web/rest',
  filesDomain: 'http://localhost:8080',
  */
   //PRE 
  //apiUrl: 'https://10.112.230.68:8445/maxiplus-web/rest', //old http://10.112.230.68:8081/maxiplusAdm-web/rest
  //filesDomain: 'https://10.112.230.68:8445',
  
   //PROD
  apiUrl: 'https://www.maxiplus.ec/maxiplus-web/rest',
  filesDomain: 'https://www.maxiplus.ec',

  retryTimes: 1
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
